import PermissionHide from 'components/PermissionHide';
import React from 'react';
import { FormattedNumber } from 'react-intl';
import { useObservable } from 'react-use-observable';
import IconPaymentMethod from 'v2/components/Shared/IconPaymentMethod';
import WhatsAppLink from 'v2/components/Shared/WhatsAppLink';
import ordersService from 'v2/services/orders';

import useStyle from './styles';

const DELIVERY_TYPE = {
  1: 'Grátis',
  2: 'Valor Fixo',
  3: 'Correios',
};

const MAIL_TYPE = {
  '04510': 'PAC',
  '04014': 'SEDEX',
};

const Customer = () => {
  const classes = useStyle();
  const [order] = useObservable(() => ordersService.getOrder(), []);

  if (!order) {
    return null;
  }

  return (
    <div className={classes.customer}>
      {order.customer?.name && (
        <div>
          <span>Nome: </span>
          <PermissionHide action='myeduzz:minhas-entregas:ver-dados-clientes'>{order.customer.name}</PermissionHide>
          <PermissionHide inverse={true} action='myeduzz:minhas-entregas:ver-dados-clientes'>
            <em>oculto</em>
          </PermissionHide>
        </div>
      )}
      {order.customer?.email && (
        <div>
          <span>E-mail: </span>
          <PermissionHide action='myeduzz:minhas-entregas:ver-dados-clientes'>{order.customer.email}</PermissionHide>
          <PermissionHide inverse={true} action='myeduzz:minhas-entregas:ver-dados-clientes'>
            <em>oculto</em>
          </PermissionHide>
        </div>
      )}
      {order.customer?.celphone && (
        <div>
          <span>Fone: </span>
          <PermissionHide action='myeduzz:minhas-entregas:ver-dados-clientes'>
            <WhatsAppLink phone={order.customer.celphone} />
          </PermissionHide>
          <PermissionHide inverse={true} action='myeduzz:minhas-entregas:ver-dados-clientes'>
            <em>oculto</em>
          </PermissionHide>
        </div>
      )}
      {order.payment_method?.id && (
        <div>
          <span>Forma de pagamento: </span>
          <IconPaymentMethod cardBrand={order.card_brand} /> {order.payment_method.name}
          {order.card_number ? ` - ${order.card_number}` : ''}
        </div>
      )}
      {order.delivery_type?.tipofrete !== '1' && (
        <>
          <span>Valor total frete: </span>
          <PermissionHide inverse={1} action='myeduzz:minhas-entregas:ocultar-valores'>
            <FormattedNumber format='BRL' value={order.freight_value} />
          </PermissionHide>
          <PermissionHide inverse={false} action='myeduzz:minhas-entregas:ocultar-valores'>
            <em>oculto</em>
          </PermissionHide>
        </>
      )}
      {order.delivery_type && (
        <div>
          <span>Tipo de frete: </span>
          <PermissionHide inverse={1} action='myeduzz:minhas-entregas:ocultar-valores'>
            {order.delivery_type?.tipofrete ? DELIVERY_TYPE[order.delivery_type.tipofrete] : 'Desconhecido'}
            {MAIL_TYPE[order.mail_type] ? ` (${MAIL_TYPE[order.mail_type]})` : ''}
          </PermissionHide>
          <PermissionHide inverse={false} action='myeduzz:minhas-entregas:ocultar-valores'>
            <em>oculto</em>
          </PermissionHide>
        </div>
      )}
      {order.delivery_type?.prazo_frete >= 0 && (
        <div>
          <span>Prazo exibido ao cliente: </span>
          <PermissionHide inverse={1} action='myeduzz:minhas-entregas:ocultar-valores'>
            {order.delivery_type.prazo_frete} dia(s)
          </PermissionHide>
          <PermissionHide inverse={false} action='myeduzz:minhas-entregas:ocultar-valores'>
            <em>oculto</em>
          </PermissionHide>
        </div>
      )}
      {order.customer?.address && (
        <div>
          <span>Endereço: </span>
          <PermissionHide action='myeduzz:minhas-entregas:ver-dados-clientes'>
            {order.customer.address.street && `${order.customer.address.street}, `}
            {order.customer.address.number && `${order.customer.address.number} - `}
            {order.customer.address.complement && `${order.customer.address.complement} - `}
            {order.customer.address.neighborhood && `${order.customer.address.neighborhood} - `}
            {order.customer.address.zip_code && `CEP ${order.customer.address.zip_code} - `}
            {` ${order.customer.address.city} / ${order.customer.address.state}`}
          </PermissionHide>
          <PermissionHide inverse={true} action='myeduzz:minhas-entregas:ver-dados-clientes'>
            <em>oculto</em>
          </PermissionHide>
        </div>
      )}
    </div>
  );
};
export default Customer;
